module.exports = __webpack_public_path__ + "static/media/game_background.8805b4bc.png";